/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Stripe_Connect_Audit_LogInputs */

const en_stripe_connect_audit_log = /** @type {(inputs: Stripe_Connect_Audit_LogInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Initiated Stripe Connect onboarding/dashboard access`)
};

const es_stripe_connect_audit_log = /** @type {(inputs: Stripe_Connect_Audit_LogInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Inició la integración/acceso al panel de Stripe Connect`)
};

const fr_stripe_connect_audit_log = /** @type {(inputs: Stripe_Connect_Audit_LogInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Initialisation de l'intégration Stripe Connect / accès au tableau de bord`)
};

const de_stripe_connect_audit_log = /** @type {(inputs: Stripe_Connect_Audit_LogInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Hat Stripe Connect Onboarding/Dashboard-Zugriff initiiert`)
};

const id_stripe_connect_audit_log = /** @type {(inputs: Stripe_Connect_Audit_LogInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Menginisiasi pendaftaran/akses Dasbor Stripe Connect`)
};

/** @type {(inputs: Stripe_Connect_Audit_LogInputs) => LocalizedString} */
const ja_stripe_connect_audit_log = en_stripe_connect_audit_log;

/** @type {(inputs: Stripe_Connect_Audit_LogInputs) => LocalizedString} */
const zh_stripe_connect_audit_log = en_stripe_connect_audit_log;

/** @type {(inputs: Stripe_Connect_Audit_LogInputs) => LocalizedString} */
const ar_stripe_connect_audit_log = en_stripe_connect_audit_log;

/** @type {(inputs: Stripe_Connect_Audit_LogInputs) => LocalizedString} */
const it_stripe_connect_audit_log = en_stripe_connect_audit_log;

/** @type {(inputs: Stripe_Connect_Audit_LogInputs) => LocalizedString} */
const ru_stripe_connect_audit_log = en_stripe_connect_audit_log;

/** @type {(inputs: Stripe_Connect_Audit_LogInputs) => LocalizedString} */
const pt_stripe_connect_audit_log = en_stripe_connect_audit_log;

/** @type {(inputs: Stripe_Connect_Audit_LogInputs) => LocalizedString} */
const ko_stripe_connect_audit_log = en_stripe_connect_audit_log;

/**
* | output |
* | --- |
* | "Initiated Stripe Connect onboarding/dashboard access" |
*
* @param {Stripe_Connect_Audit_LogInputs} inputs
* @param {{ locale?: "en" | "es" | "fr" | "de" | "ja" | "zh" | "ar" | "id" | "it" | "ru" | "pt" | "ko" }} options
* @returns {LocalizedString}
*/
export const stripe_connect_audit_log = /** @type {((inputs?: Stripe_Connect_Audit_LogInputs, options?: { locale?: "en" | "es" | "fr" | "de" | "ja" | "zh" | "ar" | "id" | "it" | "ru" | "pt" | "ko" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Stripe_Connect_Audit_LogInputs, { locale?: "en" | "es" | "fr" | "de" | "ja" | "zh" | "ar" | "id" | "it" | "ru" | "pt" | "ko" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_stripe_connect_audit_log(inputs)
	if (locale === "es") return es_stripe_connect_audit_log(inputs)
	if (locale === "fr") return fr_stripe_connect_audit_log(inputs)
	if (locale === "de") return de_stripe_connect_audit_log(inputs)
	if (locale === "ja") return ja_stripe_connect_audit_log(inputs)
	if (locale === "zh") return zh_stripe_connect_audit_log(inputs)
	if (locale === "ar") return ar_stripe_connect_audit_log(inputs)
	if (locale === "id") return id_stripe_connect_audit_log(inputs)
	if (locale === "it") return it_stripe_connect_audit_log(inputs)
	if (locale === "ru") return ru_stripe_connect_audit_log(inputs)
	if (locale === "pt") return pt_stripe_connect_audit_log(inputs)
	return ko_stripe_connect_audit_log(inputs)
});